import { render, staticRenderFns } from "./ModelNase.vue?vue&type=template&id=c35270e6&scoped=true"
import script from "./ModelNase.vue?vue&type=script&lang=js"
export * from "./ModelNase.vue?vue&type=script&lang=js"
import style0 from "./ModelNase.vue?vue&type=style&index=0&id=c35270e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35270e6",
  null
  
)

export default component.exports